import { DownloadOutlined } from "@toddle-edu/ds-icons";
import { Button } from "@toddle-edu/ds-web";
import _ from "lodash";
import DownloadTranscriptsModal from "TranscriptsV3/components/DownloadTranscriptsModal";
import React, { memo, useCallback, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import SkeletonLoader from "UIComponents/SkeletonLoader";
import { useTranscriptsPermissions } from "TranscriptsV3/context/TranscriptsPermissionContext";
import { canManageDownloads } from "TranscriptsV3/modules/PermissionHelpers";

const TEST_ID_PREFIX = "transcriptsV3-preview-downloadButton";

const DownloadButton = ({
  schoolId,
  studentId,
  isLoading,
  templates,
  selectedTemplate,
  studentName,
}) => {
  const { t } = useTranslation();
  const [showModal, setShowModal] = useState(false);

  const permissionMap = useTranscriptsPermissions();

  const canShowDownload = canManageDownloads({
    permissionMap,
    schoolId,
  });

  const toggleModal = useCallback(() => {
    setShowModal(prev => !prev);
  }, []);

  const template = useMemo(
    () => ({
      value: selectedTemplate?.id,
      label: selectedTemplate?.name || t("common:untitled"),
    }),
    [selectedTemplate?.id, selectedTemplate?.name, t]
  );

  if (isLoading) return <SkeletonLoader height="36px" width="184px" />;
  if (!canShowDownload) return null;
  if (_.isEmpty(templates)) return null;

  return (
    <>
      <Button
        icon={<DownloadOutlined />}
        testId={TEST_ID_PREFIX}
        onClick={toggleModal}
        aria-haspopup="dialog"
        aria-expanded={showModal}
      >
        {t("common:download_with_label", {
          label: t("transcript:transcript"),
        })}
      </Button>
      {showModal ? (
        <DownloadTranscriptsModal
          studentIds={[studentId]}
          schoolIds={[schoolId]}
          onClose={toggleModal}
          selectedTemplate={template}
          studentName={studentName}
          testId={TEST_ID_PREFIX}
        />
      ) : null}
    </>
  );
};

export default memo(DownloadButton);
